export enum IStepType {
	ClientStep,
	MessageStep,
}
